import { render } from "./UrlRegistro.vue?vue&type=template&id=2a1205a3"
import script from "./UrlRegistro.vue?vue&type=script&lang=js"
export * from "./UrlRegistro.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__